// Real customer quotes shown on the home page. Add entries as users grant
// permission (collected via the delivery email's reply ask). The Testimonials
// component renders nothing while this list is empty.
export interface Testimonial {
  quote: string;
  name: string;     // e.g. "Jane V."
  location: string; // e.g. "Austin, TX"
}

export const TESTIMONIALS: Testimonial[] = [];
